import { BookingChannel } from "components/booking_details/BookingChannel";
import { Dates } from "components/booking_details/Dates";
import { EarlyCheckinOption } from "components/booking_details/EarlyCheckinOption";
import { LengthOfStay } from "components/booking_details/LengthOfStay";
import { NumberOfGuests } from "components/booking_details/NumberOfGuests";
import { PropertyStatusAlerts } from "components/booking_details/PropertyStatusAlerts";
import ReservationDetails from "components/booking_details/ReservationDetails";
import BookingOrPropertyNotes from "components/BookingOrPropertyNotes";
import UpdateReservationTimes from "scenes/thread/components/UpdateReservationTimes";

import { MultiplatGuestDetails } from "./MultiplatGuestDetails";

export const MultiplatBookingDetails = ({
  property,
  booking,
  reservation,
  refetchBookings
}) => {
  if (!booking) return null;

  const {
    checkin_date,
    checkout_date,
    checkin,
    checkout,
    checkin_time,
    checkout_time
  } = booking;

  if (!checkin_date || !checkout_date) return null;

  return (
    <>
      <PropertyStatusAlerts property={property} checkin_date={checkin_date} />
      <div className="BookingDetails__stay">
        <NumberOfGuests
          property={property}
          booking={booking}
          reservation={reservation}
        />
        <LengthOfStay
          property={property}
          checkin={checkin_date}
          checkout={checkout_date}
        />
        <BookingChannel booking={booking} />
      </div>
      <div className="BookingDetails__stay">
        <Dates
          checkin={checkin}
          checkout={checkout}
          checkinTime={checkin_time}
          checkoutTime={checkout_time}
        />
        <ReservationDetails
          reservation={reservation}
          booking={booking}
          isMultiplat
        />
      </div>
      <div className="BookingDetails__stay">
        <EarlyCheckinOption booking={booking} />
      </div>
      <div className="BookingDetails__dates">
        <span className="BookingDetails__dates--update">
          <UpdateReservationTimes
            booking={booking}
            refreshThread={refetchBookings}
          />
        </span>
      </div>

      <MultiplatGuestDetails
        booking={booking}
        refreshThread={refetchBookings}
      />

      <BookingOrPropertyNotes bookingOrProperty={booking} type="booking" />
    </>
  );
};
